import {GetValidateBankParams} from 'domain/usecases/private/refund/request/get-validate-bank';
import {makeGetValidateBank} from 'main/factories/usecases/private/refund/request/get-validate-bank';

export async function validateRefundBank(params: GetValidateBankParams) {
	const response = await makeGetValidateBank().get(params);

	return response?.content ?? null;
}
